const comments = [
  {
    name: '动漫小王子',
    avatar: 'ri-user-3-line',
    time: '3天前',
    content: '用了51动漫网之后就把其他站都删了！下拉式阅读真的爽，追漫效率直接翻倍，而且画质是真的清晰，1080P看着太过瘾了。',
    likes: '256',
  },
  {
    name: '二次元少女',
    avatar: 'ri-user-heart-line',
    time: '5天前',
    content: '国漫资源太全了！斗破苍穹、完美世界、凡人修仙传全都有，每周第一时间更新，再也不用到处找资源了。',
    likes: '189',
  },
  {
    name: '追番狂人',
    avatar: 'ri-user-star-line',
    time: '1周前',
    content: '日漫韩漫国漫三合一太方便了，一个站搞定所有需求。推荐给身边所有喜欢动漫的朋友了，大家都说好用！',
    likes: '312',
  },
  {
    name: '深夜补番人',
    avatar: 'ri-moon-line',
    time: '2周前',
    content: '半夜睡不着就来刷几集，加载速度是真的快，一点都不卡。经典老番也有收录，怀旧党狂喜！',
    likes: '178',
  },
  {
    name: '漫画收藏家',
    avatar: 'ri-bookmark-line',
    time: '3周前',
    content: '日漫区分类特别细致，按类型、年份、热度都能筛选。下拉式阅读模式太适合追长篇了，一口气能看几十话。',
    likes: '445',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-heading text-foreground-950">用户评价</h2>
          <p className="mt-3 text-sm text-foreground-600">来自动漫爱好者们的真实反馈，口碑见证品质</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {comments.map((item) => (
            <div key={item.name} className="rounded-2xl p-5 bg-background-100 border border-background-200/70">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className={`${item.avatar} text-sm text-primary-500`}></i>
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-medium text-foreground-950 truncate">{item.name}</p>
                  <p className="text-[10px] text-foreground-500">{item.time}</p>
                </div>
              </div>
              <p className="text-xs text-foreground-600 leading-relaxed line-clamp-4">{item.content}</p>
              <div className="mt-3 flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{item.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}